import React from 'react';
import PropTypes from 'prop-types';

export default class GDSelectUserValueMulti extends React.Component {

    static propTypes = {
        values: PropTypes.array,

        additionalOptions: PropTypes.array,     // array of objects to add to options, first usage to add "Not assigned" option

        renderValue: PropTypes.oneOf(['name', 'icon-name', 'icon', 'inline', 'form-icon-name', 'form', 'func']).isRequired, // render value view name
        renderValueFunc: PropTypes.func,        // func for external render function if passed used to render instead of default

        placeholder: PropTypes.string,          // If no value selected string we display

        onTogglePopover: PropTypes.func
    }

    renderIconName() {
        const usersCount = this.props.values && this.props.values.length ? this.props.values.length : 0;

        if (usersCount > 0) {
            let userItems = this.props.values.map(uId => {
                const user = _.find(this.props.additionalOptions, ao=>ao.id === uId) || gd.session.users.get(uId);
                if (user) {
                    return <span className="name m-r-5" key={uId}>{user.name}</span>;
                } else {
                    console.error('no user found');
                    return false;
                }
            });

            return (
                <div className="cur-value">
                    {userItems}
                </div>
            );
        } else {
            return (
                <div className="cur-value no-val">
                    <span key="name">{this.props.placeholder}</span>
                </div>
            );
        }
    }

    renderForm() {
        const usersCount = this.props.values && this.props.values.length ? this.props.values.length : 0;

        if (usersCount > 0) {
            let userItems = this.props.values.map(uId => {
                const user = _.find(this.props.additionalOptions, ao=>ao.id === uId) || gd.session.users.get(uId);
                if (user) {
                    return <span className="item" key={uId}>{user.name}</span>;
                } else {
                    console.error('no user found');
                    return false;
                }
            });

            return (
                <div className="element-content has-value">
                    {userItems}
                    <div key="arrow" className="arrow-icon i5-big-angle-down" />
                </div>
            );
        } else {
            return (
                <div className="element-content no-value">
                    <span key="label">{this.props.placeholder}</span>
                    <div key="arrow" className="arrow-icon i5-big-angle-down" />
                </div>
            );
        }
    }

    renderFunc() {
        return this.props.renderValueFunc(this.props.values);
    }

    render() {
        let res;

        switch (this.props.renderValue) {
            case 'icon-name': res = this.renderIconName(); break;
            case 'form'     : res = this.renderForm(); break;
            case 'func'     : res = this.renderFunc(); break;
        }

        return <div className="value-container pop-target" onClick={this.props.onTogglePopover}>{res}</div>
    };
}